import type { RouteLocationNormalized } from 'vue-router'

export const ErrorRouteName = {
  ErrorClientUnsupported: 'ErrorClientUnsupported',
  ErrorCountryUnsupported: 'ErrorCountryUnsupported'
} as const

export class UserClientUnsupportedError extends Error {
  userClient: string

  constructor(userClient: string) {
    super()
    this.userClient = userClient
    this.name = 'UserClientUnsupportedError'
    this.message = `Tried to route with unsupported client: ${userClient}`
  }
}

export const isErrorRoute = (route: RouteLocationNormalized) =>
  (route.name ?? '').toString() in ErrorRouteName
